import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { DelayedJobsCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { DelayedJobTable } from "./table";

export default function DelayedJob() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Table des éléments inconnus");
  }, []);

  return (
    <Routes>
      <Route index element={<DelayedJobTable />} />

      <Route path=":id" element={<DelayedJobsCard />} />
    </Routes>
  );
}
